// Generated from SVG to Code Figma Plugin

export const BaseLineCheckUnpick = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g opacity="0.64">
      <rect height="16" width="20" rx="3" stroke="currentColor" strokeWidth="1.5" x="2" y="4" />
      <path
        d="M8 15C8.66667 14.6667 10 14 12 14C14 14 15.3333 14.6667 16 15"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="1.5"
      />
      <path d="M8 10L8 11" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
      <path d="M16 10L16 11" stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" />
    </g>
  </svg>
);
